import { RootState } from "store/store";
import { compose } from "redux";
import { connect } from "react-redux";
import DeletePartnerButton from "./DeletePartnerButton";
import {
    getPartnerId,
    getPartnerName,
} from "store/partners/partners-selectors";
import { setLoaderVisibility } from "store/common/initialization/initialization-actions";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";

const mapStateToProps = (state: RootState) => {
    return {
        partnerName: getPartnerName(state),
        partnerId: getPartnerId(state),
    };
};

const DeletePartnerButtonContainer = compose(
    connect(mapStateToProps, {
        setLoaderVisibility,
        setIsUnsavedChangeAvailable,
    })
)(DeletePartnerButton);

export default DeletePartnerButtonContainer;
